import { render, staticRenderFns } from "./ProfessionalReferenceShortForm.vue?vue&type=template&id=e600eba8&"
import script from "./ProfessionalReferenceShortForm.vue?vue&type=script&lang=ts&"
export * from "./ProfessionalReferenceShortForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProfessionalReferenceShortForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports